<template>
    <div class="mb-3">
        <label :for="id" class="form-label">{{ label }}</label>
        <Field :name="name" :model-value="modelValue" @update:model-value="$emit('update:modelValue', $event)"
            v-slot="{ field, meta, errorMessage }">
            <div :class="{ 'au-input-icon': !!icon }">
                <i v-if="icon" :class="['bi', icon]"></i>
                <select v-if="options" :id="id" v-bind="field" class="form-select"
                    :class="stateClass(meta, errorMessage)" :aria-invalid="isInvalid(meta, errorMessage)">
                    <option value="" disabled>{{ placeholder }}</option>
                    <option v-for="option in options" :key="String(option.value)" :value="option.value">
                        {{ option.label }}
                    </option>
                </select>
                <input v-else :id="id" v-bind="field" :type="type" :autocomplete="autocomplete"
                    :placeholder="placeholder" class="form-control" :class="stateClass(meta, errorMessage)"
                    :aria-invalid="isInvalid(meta, errorMessage)" />
            </div>
            <div v-if="isInvalid(meta, errorMessage)" class="invalid-feedback d-block">{{ errorMessage }}</div>
        </Field>
        <div v-if="hint" class="form-text">{{ hint }}</div>
    </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";
import { Field } from "vee-validate";

type FieldMeta = { valid: boolean; touched: boolean };
type FieldOption = { value: string | number; label: string };

// Pole formularza walidowane przez vee-validate, jak w głównej aplikacji: obramowanie i komunikat po dotknięciu pola
export default defineComponent({
    name: "FormField",
    components: { Field },
    props: {
        name: { type: String, required: true },
        label: { type: String, required: true },
        modelValue: { type: [String, Number], default: "" },
        id: { type: String, required: true },
        type: { type: String, default: "text" },
        autocomplete: { type: String, default: "off" },
        placeholder: { type: String, default: "" },
        icon: { type: String, default: "" },
        hint: { type: String, default: "" },
        options: { type: Array as PropType<FieldOption[]>, default: null },
    },
    emits: ["update:modelValue"],
    methods: {
        isInvalid(meta: FieldMeta, errorMessage?: string): boolean {
            return !!errorMessage && meta.touched;
        },
        stateClass(meta: FieldMeta, errorMessage?: string): Record<string, boolean> {
            return {
                "is-valid": meta.valid && meta.touched,
                "is-invalid": this.isInvalid(meta, errorMessage),
            };
        },
    },
});
</script>
